<template>
  <div class="mb-3">
    <label class="form-label"
      >{{ data.label
      }}<span
        class="asterisk"
        :class="mode == 'write' ? 'red' : ''"
        v-if="data.mandatory"
        >*</span
      ></label
    >
    <select
      :id="data.id"
      class="form-select"
      :class="isValid ? '' : 'error'"
      :disabled="isDisable"
      v-if="mode == 'write'"
      v-model="selectVal"
      @change.stop="checkValid()"
    >
      <option selected :key="-1">請選擇</option>
      <option
        :value="item.optionValue"        
        v-for="(item, idx) in data.infoInputOptions"
        :key="idx"
        :selected="item.selected"
      >
        {{ item.optionValue }}
      </option>
    </select>
    <div class="form-text error_msg" v-if="!isValid && mode == 'write'">
      請選擇{{ data.label }}！
    </div>
    <div class="input_answer" v-if="mode == 'read'">
      {{ answer.length > 0 ? answer.toString() : "未選擇" }}
    </div>
    <div v-if="data.label == '送遞地區'" style="padding-top: 10px; padding-left: 2px;">
      <p>送遞費HKD30，約於產品確認3個工作天後送到。送遞範圍以送遞公司回覆為準，未能派送之訂單本公司職員將聯絡旅客退回送遞費及安排分行領取。</p>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import useEventBus from "@/config/eventBus";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const isValid = ref(true);
    const isDisable = ref(false);
    const eventBus = useEventBus();
    const selectVal = ref("請選擇");

    const answer = computed(() =>
      props.data.infoInputOptions
        .filter((item) => item.selected)
        .map((item) => item.optionValue)
    );

    const checkValid = () => {
      if (props.mode == "write") {
        if (props.data.questionKey == "collect_method") {
          eventBus.emit("changeCollectMethod", selectVal.value);
        }
        if (props.data.mandatory) {
          selectVal.value == "請選擇"
            ? (isValid.value = false)
            : (isValid.value = true);
        }
      }
      if (props.mode == "write") {          
        eventBus.emit("selectValue", {
          id: props.data.id,
          val: selectVal.value,
          data: props.data,
        });
        if (props.data.questionKey.toUpperCase().includes("CHILD_COUNT")) {
          eventBus.emit("changeChildCount", selectVal.value);
        } else if (
          props.data.questionKey.toUpperCase().includes("PASSENGER_COUNT")
        ) {
          eventBus.emit("changeDriverNumber", selectVal.value);
        }
      }
    };

    onMounted(() => {
      console.log(props.data);
      props.data.infoInputOptions.forEach(function (i) {
        if (i.selected) selectVal.value = i.optionValue;
      });

      eventBus.on("checkValid", () => {
        document
          .getElementById(props.data.id)
          .dispatchEvent(new Event("change"));
      });
      eventBus.on("resetSelectedValue", (questionKey) => {
        if(props.data.dependQuestionKey==questionKey){
          props.data.infoInputOptions.forEach(function(option) {
             option.selected=false;
          })
          selectVal.value = "請選擇";
          eventBus.emit("resetSelectedValue", props.data.questionKey);
        }   
      });
    });
    eventBus.on("disableList", () => {
    	isDisable.value = true;
      });
    eventBus.on("enableList", () => {
    	isDisable.value = false;
      });
    
    onBeforeUnmount(() => {
      eventBus.off("checkValid");
    });

    return {
      selectVal,
      answer,
      isValid,
      isDisable,
      checkValid,
    };
  },
};
</script>

